import { ProjectFormData } from "../Models/ProjectFormData";
import { RestApiRequest } from "../Models/RestApiRequest";
import { fetchData } from "./BaseService";
import { ProjectDailyJob } from "../Models/ProjectDailyJobs";

export const createProjectAsync = async (projectName: string) => {
  var request: RestApiRequest = {
    url: "/api/projects/project/create?projectname=" + projectName,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await fetchData(request);
  return response;
};

export const getProjectsAsync = async () => {
  var request: RestApiRequest = {
    url: "/api/dealeradmins/user/projects",
    method: "GET",
  };
  const response = await fetchData(request);
  return response;
};

export const getProjectAsync = async (projectId: number) => {
  var request: RestApiRequest = {
    url: "/api/projects/projectdetails?projectid=" + projectId,
    method: "GET",
  };
  const response = await fetchData(request);
  return response;
};

export const isProjectUnique = async (projectName: string) => {
  var request: RestApiRequest = {
    url: "/api/projects/project/isunique?projectname=" + projectName,
    method: "GET",
  };
  const response = await fetchData(request);
  return response;
};

export const updateProjectAsync = async (projectData: ProjectFormData) => {
  // When updating project data, add time
  projectData.dailyJobs = updateCronExpressions(projectData.dailyJobs, projectData.timeZone);
  var request: RestApiRequest = {
    url: "/api/projects/projectdetails/update",
    method: "PUT",
    body: projectData,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await fetchData(request);
  return response;
};

export const getDealersAsync = async () => {
  var request: RestApiRequest = {
    url: "/api/dealers/all",
    method: "GET",
  };
  const response = await fetchData(request);
  return response;
};

export const deleteProjectAsync = async (projectName: string) => {
  var request: RestApiRequest = {
    url: "/api/projects/project/delete?projectname=" + projectName,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await fetchData(request);
  return response;
};

export const sendEmailToLMCSupportAsync = async (subject: string, body: string) => {
    var request: RestApiRequest = {
        url: "/api/utils/email/sendtolmcsupport",
        method: "POST",
        body: { subject: subject, body: body },
        headers: {"Content-Type": "application/json"},
    };

  const response = await fetchData(request);
  return response;
}

const updateCronExpressions = (dailyJobs: ProjectDailyJob[] | undefined, timeOffset: number): ProjectDailyJob[] | undefined => {
    if (dailyJobs != undefined) {
        return dailyJobs.map(job => {
            if (timeOffset != undefined) {
                // Split the cron expression into its components
                const cronParts = job.cronexpression.split(" ");
        
                if (cronParts.length < 5) {
                    console.error(`Invalid cron expression for job: ${job.name}`);
                    return job; // Return the job as is if the cron expression is invalid
                }

                // Parse the hour part (second part of cron expression)
                let hour = parseInt(cronParts[2]);

                if (!isNaN(hour)) {
                    // Add 24h in case hour - timeOffset goes negative
                    hour = (24 + hour - timeOffset) % 24;

                    // Update the cron expression with the new hour
                    cronParts[2] = hour.toString();
                }

                // Join the cron parts back together into a valid cron expression
                job.cronexpression = cronParts.join(" ");
            }

            // Return the modified job
            return job;
        });
    }

    return undefined;
};